import { render, staticRenderFns } from "./Pegase.vue?vue&type=template&id=c3c7e646&"
import script from "./Pegase.vue?vue&type=script&lang=js&"
export * from "./Pegase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports